import { useMemo } from 'react'
import { Grid } from '@mui/material'
import DropdownMenu from '../../../shared/UI/DropdownMenu'
import { getSelectValuesByType } from '../../../utils/app-utils'
import { SelectOption } from '../../../services/dashboardService'
import DateTimePicker from '../../../shared/UI/DateTimePickerV2'

interface ContactMadeProps {
  contactMadeBy?: SelectOption
  setContactMadeBy: (value: SelectOption) => void
  contactDateTime: Date | null
  setContactDateTime: (value: Date | null) => void
  contactMadeByError?: boolean
}

function ContactMade({
  contactMadeBy,
  setContactMadeBy,
  contactDateTime, 
  setContactDateTime,
  contactMadeByError = false,
}: ContactMadeProps) {
  const options = useMemo(() => getSelectValuesByType('ContactByType'), [])

  return (
    <>
      <Grid item xs={12} md={12}>
        <DropdownMenu
          label="Contact made by"
          id="year-select"
          data={options}
          textField="displayValue"
          valueField="value"
          name="contactedByTypeId"
          value={contactMadeBy?.value ?? 0}
          onChange={event => {
            const newId = Number(event.target.value)
            const newValue = options.find(x => x.value === newId)
            if (!newValue) {
              return
            }
            setContactMadeBy(newValue)
            setContactDateTime(newValue.value !== undefined && newValue.value > 0 ? new Date(): null)
          }}
          error={contactMadeByError}
        />
      </Grid>
      {(contactMadeBy?.value === 1 || contactMadeBy?.value === 2) && (
        <Grid item xs={12} md={12}>
          <DateTimePicker
            id="contactedDate"
            label="Contacted date"
            required
            value={contactDateTime}
            onChange={newValue => {
              setContactDateTime(newValue)
            }}
          />
        </Grid>
      )}
    </>
  )
}

export default ContactMade
